"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiClient = void 0;
class ApiClient {
    constructor(appKey, http) {
        this.appKey = appKey;
        this.http = http;
    }
    getDeviceStatus(deviceInfo) {
        const payload = {
            app_token: this.appKey,
            device: deviceInfo,
        };
        return this.http.post('/app/device-status', payload).then(response => {
            const hasError = typeof response.error !== 'undefined';
            const isAppValid = !hasError || hasError && response.error.code !== -1004;
            const isDeviceEnabled = typeof response.logger_enabled !== 'undefined' ? response.logger_enabled : false;
            return { isDeviceEnabled, isAppValid };
        });
    }
    sendSession(session) {
        return this.http.post('/session', session);
    }
    sendLogs(sessionId, logs) {
        return this.http.post('/log/batch', {
            session_id: sessionId,
            logs: logs,
        });
    }
    sendIssue(uuid, issueURL, title, text, type, sessionId) {
        const payload = {
            uid: uuid,
            title: title,
            text: text,
            app: { key: this.appKey },
            type: type,
            session_id: sessionId,
        };
        return this.http.post('/issue', payload).then(() => {
            return { uuid, issueURL };
        });
    }
    setDeviceKey(deviceId, key, value) {
        return this.http.post('/device/keyvalue', {
            app_key: this.appKey,
            device_id: deviceId,
            key: key,
            value: value,
        });
    }
}
exports.ApiClient = ApiClient;
